var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-image"},[(_vm.url)?_c('b-img',{attrs:{"id":_vm.id,"src":_vm.url}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }